manageIgnoredMonthlyInspections();

function manageIgnoredMonthlyInspections(){

    var AjaxController = require('../../services/AjaxController');

    console.log('js ignore monthly inspection checkbox');

    $('.js-ignore-monthly-inspection-checkbox').on('click', function(){

        var $this = $(this),
            property_id = $this.data('property-id'),
		    month = $this.data('month'),
            year = $this.data('year'),
            url = '/properties/monthly-inspections/ignore';

        var data = {
            property_id: property_id,
            month : month,
            year : year,
            value: ($this.prop('checked')) ? 1 : 0
        };
        var success = function (response) {
            //console.log('Success');
        }
        var error = function (response) {
            //console.log('Error');
        }

        AjaxController.prototype.send(url, data, success, error);
    });


};